// extracted by mini-css-extract-plugin
export var boxItems = "_63-1";
export var button = "_63-5";
export var filterGroupBox = "_63-0";
export var icon = "_63-2";
export var iconSecondary = "_63-4";
export var iconWrapper = "_63-3";